<template>
    <div>
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">高龄怀孕</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">早期阵痛与早产</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">妊娠期高血压性疾病</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">妊娠期糖尿病</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">前置胎盘</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">宫颈机能不全</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==7}" @click="lnbFn(7)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step7')">Multiple Pregnancy</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==8}" @click="lnbFn(8)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step8')">胎儿治疗</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==9}" @click="lnbFn(9)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step9')">产后出血</a>
                </li>
            </ul>
        </div>
        <div id="step1" class="step-item info">
            <h3 class="bullet01">高龄怀孕</h3>
            <p class="depth">
                近年来，随着经济能力的提升和晚婚现象的普遍化，超过适宜生育年龄结婚或因各种原因选择晚育的女性人数不断增加。
                <br>
                高龄孕妇被定义为35岁及以上怀孕的女性，无论是否为首次分娩，均被视为高危孕妇。在韩国，35岁以上孕妇所占比例逐渐上升。
                <br>
                与年轻孕妇相比，高龄孕妇在流产、胎儿先天畸形、高血压、妊娠中毒症、子宫肌瘤、胎位异常、难产、机械助产、剖宫产、低出生体重儿以及早产等方面发生率更高，新生儿发病率和新生儿死亡率也相对较高。
                <br>
                但如果35岁以上的高龄孕妇能够寻求专科医生的帮助，并接受适当的咨询与护理，将可以实现健康怀孕并安全分娩。
            </p>
            <h4 class="bullet02 type2 num1 depth">定期接受健康检查</h4>
            <p class="depth">
                确认自己是否存在未察觉的疾病或其他问题，以确保在身心状态健康的情况下有计划地怀孕，从而实现健康妊娠和顺利分娩。
            </p>

            <h4 class="bullet02 type2 num2 depth">定期进行产前检查</h4>
            <p class="depth">
                高龄孕妇生出畸形婴儿的可能性约是年轻孕妇的1.5倍。胎儿染色体异常可以通过早期畸形儿筛查以及绒毛膜和羊水检查来确认。此外，通过超声波检查，可以及时发现胎儿是否存在任何异常，并据此制定未来治疗及分娩计划。
            </p>

            <h4 class="bullet02 type2 num3 depth">通过定期产前护理预防妊娠并发症</h4>
            <p class="depth">
                高龄怀孕面临多种妊娠并发症风险，随着妊娠高血压和妊娠糖尿病发病率不断增加，管理好妊娠期间体重及饮食显得尤为重要。应注意控制体重增长，保持适度运动，并避免辛辣或过咸食物，以降低妊娠并发症发生概率。
            </p>
        </div>

        <div id="step2" class="step-item info">
            <h3 class="bullet01">早期阵痛与早产</h3>
            <p class="depth">
                大约有10%的孕妇会经历早产，早产生下的新生儿可能会严重影响其后续成长发育，还可能导致出生后数年的成长问题。本院预防早产门诊致力于通过尽早识别早期阵痛相关征兆并实施恰当治疗，帮助孕妇减少早产风险。
                <br>
                同时，我们密切关注孕妇的妊娠周数、胎儿数量及状况，根据孕妇个人情况考虑采取宫颈结扎术或黄体酮治疗，以预防早产。此外，还提供针对最重要的产前管理、药物治疗、手术治疗等的指导和咨询。
            </p>
            <h4 class="bullet02 type2 num1 depth">早产的原因</h4>
            <p class="bullet04 num1 depth">1/3是因并发症导致的早产</p>
            <p class="bullet05 depth">
                大约1/3的早产是由于胎盘出血和高血压疾病所导致的不可避免的情况，其余2/3则是自然发生的早产，伴随或不伴随羊膜破裂
            </p>
            <p class="bullet04 num2 depth">不良生活习惯也是导致早产的原因</p>
            <p class="bullet05 depth">
                吸烟、饮酒、滥用药物、营养摄取不足或超常增重等都可能导致新生儿出生体重过低。其中，尤其是产妇体重增加异常是增加早产风险的重要因素。此外，饮酒不仅会带来早产的风险，还会导致胎儿脑损伤。
            </p>
            <p class="bullet04 num3 depth">羊水细菌感染是早期阵痛的原因之一</p>
            <p class="bullet05 depth">
                如果羊水被各种细菌感染，即使没有任何症状，也可能突然破裂，导致早产。在未出现羊膜破裂但已感到早期阵痛者中，大约20%的人经羊水穿刺检验发现了细菌。而对于怀孕28~35周间羊水破裂者，其结果显示在大约25%的孕妇羊水中检测到了细菌存在。
            </p>
            <p class="bullet04 num4 depth">细菌性阴道炎可能导致早产</p>
            <p class="bullet05 depth">
                阴道内生长的正常有益菌乳酸杆菌减少，其他有害菌繁殖时，可引起阴道炎，这种情况可能会导致早产、早期羊膜破裂、羊水感染。但是，并非所有细菌都会导致早产。
            </p>
            <h4 class="bullet02 type2 num2 depth">早期阵痛的症状和应急处理方法</h4>
            <p class="depth">
                如果感到骨盆受压、发生类似经痛的腹部疼痛、或下腰部疼痛并伴有阴道流血或水样分泌物，可能暗示即将早产，此时应立即来院咨询负责医生，必要时需住院治疗。
            </p>
            <h4 class="bullet02 type2 num3 depth">早产高危人群</h4>
            <p class="bullet04 num1 depth">上次怀孕时经历过早期阵痛或早产的产妇 </p>
            <p class="bullet04 num2 depth">产妇患有心脏病、肾炎、梅毒、妊娠中毒症、前置胎盘、羊水过多等疾病</p>
            <p class="bullet04 num3 depth">子宫畸形、是否使用过DES、双胎等引起的子宫增大、早期破水</p>
            <p class="bullet04 num4 depth">18岁以下的年轻孕妇</p>
            <p class="bullet04 num5 depth">35岁以上的高龄孕妇</p>
            <p class="bullet04 num6 depth">身体和精神压力过大时</p>
            <p class="bullet04 num7 depth">肾脏或尿路感染症严重者</p>
            <p class="depth mt20">
                <b>
                    符合上述情况的孕妇应仔细观察是否出现早期阵痛，并考虑早产的可能性。
                </b>
            </p>
        </div>

        <div id="step3" class="step-item info">
            <h3 class="bullet01">妊娠期高血压性疾病</h3>
            <h4 class="bullet02 type2 num1 depth">
                妊娠期高血压在妊娠20周后发生，包括
            </h4>
            <p class="bullet04 num1 depth">仅有高血压的情况；</p>
            <p class="bullet04 num2 depth">伴随高血压的蛋白尿或病理性水肿病例（先兆子痫-妊娠中毒症）；</p>
            <p class="bullet04 num3 depth">可进一步归类为伴有高血压、蛋白尿或病理性水肿并伴有癫痫发作（子痫）的情况。</p>
            <h4 class="bullet02 type2 num2 depth">诊断</h4>
            <p class="bullet04 num1 depth">
                在妊娠中期后，如果收缩压超过140mmHg，或者舒张压超过90mmHg，即可诊断为高血压。当伴有高血压的同时，24小时内收集的尿液中蛋白尿超过300mg，或在尿棒测试中发现蛋白尿为1+以上时，则可确诊为妊娠中毒症。若出现抽搐则可诊断为子痫。
            </p>
            <p class="bullet04 num2 depth">
                蛋白尿比高血压或体重增加稍微晚一些出现，怀孕时浮肿的情况也正常出现，因此即使有浮肿也不能诊断为先兆子痫。
            </p>
            <p class="bullet04 num3 depth">
                如果在怀孕20周前发生高血压，或分娩后12周内持续存在，则应被诊断为慢性高血压。
            </p>
            <h4 class="bullet02 type2 num3 depth">治疗</h4>
            <p class="bullet04 num1 depth">
                对于先兆子痫的治疗，应选择适当时机进行分娩，以尽量减少母亲和胎儿所面临的并发症。最重要的是通过对怀孕前及早期阶段进行全面管理来预防。
            </p>
            <p class="bullet04 num2 depth">
                当收缩压达到160mmHg以上、舒张压达到110mmHg以上，并且伴随一定量的蛋白尿，同时出现头痛、视力障碍、上腹痛、排尿量减少及抽搐等症状，或者发生血小板异常、肝功能异常、胎儿发育迟缓及肺水肿等情况时，可判定为严重先兆子痫，此时需考虑立即分娩。患者可能会经历剧烈头痛，上腹部疼痛及视力障碍，在某些情况下甚至会暂时失明，但大多数情况下无需手术治疗，分娩后数周内即可恢复正常状态。
            </p>
            <p class="bullet04 num3 depth">
                住院治疗：如果高血压持续存在或出现蛋白尿，可考虑住院治疗。让患者保持稳定，重症情况下，可用镁制剂防止抽搐和脑出血，必要时可用降压药，如需考虑胎儿提前分娩，可选用促进胎儿肺部成熟的药物。
            </p>
            <p class="bullet04 num4 depth">
                分娩：先兆子痫不一定需要剖腹产。如果住院后也没有好转或高血压恶化，为了产妇和胎儿的健康，会考虑分娩，但此时会考虑产妇的宫颈状态及胎儿状态等各种因素，决定是进行催产分娩还是剖腹产。
            </p>
            <h4 class="bullet02 type2 num4 depth">产后护理</h4>
            <p class="depth">
                大多数产妇在生产后健康会快速恢复，即使有高血压的产妇也可以出院。大部分产妇在2周内血压可恢复正常，分娩1周以上后尿量增多，蛋白尿和浮肿现象也基本消失。但如果高血压在分娩后3周后持续，则有可能发展为慢性高血压，需咨询专业医生。
            </p>
        </div>

        <div id="step4" class="step-item info">
            <h3 class="bullet01">妊娠期糖尿病</h3>
            <p class="depth">
                妊娠期糖尿病是指血糖高于正常范围的状态，每100名孕妇中有2~3人发生。
                <br>
                通常是降低血糖的胰岛素功效降低的状态，即胰岛素抵抗增加的状态，是在妊娠24~28周发生，分娩后消失的一种糖尿病形态。这种胰岛素抵抗是导致妊娠期糖尿病的原因。
            </p>
            <h4 class="bullet02 type2 num1 depth">诊断</h4>
            <p class="bullet04 num1 depth">妊娠24～28周时进行，在50g糖耐量试验标准值为140mg/dL以上时筛查。</p>
            <p class="bullet04 num2 depth">
                如果筛查结果为140mg/dL或更高，将进行100g或75g葡萄糖耐量试验。空腹时，服用100g/75g葡萄糖后，每隔1h测定一次血糖。进行100g糖耐量试验时，4次抽血中有2次以上结果超标；进行75g糖耐量试验时，3次抽血中有1次以上结果超标，则诊断为妊娠期糖尿病。
            </p>
            <h4 class="bullet02 type2 num2 depth">治疗</h4>
            <p class="depth">
                为了胎儿和产妇的健康，妊娠期糖尿病产妇的第一个目标是维持适当范围的血糖。孕期正常血糖为餐前60~90mg/dL，餐后2小时低于120mg/dL。
            </p>
            <p class="bullet04 num1 depth">通过自测血糖来控制血糖。</p>
            <p class="bullet04 num2 depth">实践饮食疗法。</p>
            <p class="bullet04 num3 depth">实践运动疗法。</p>
            <p class="bullet04 num4 depth">管理压力。</p>
            <p class="depth">如果无法正常控制血糖，产妇需要注射胰岛素来控制血糖。</p>
            <h4 class="bullet02 type2 num3 depth">妊娠期糖尿病对胎儿的影响</h4>
            <p class="bullet04 num1 depth">
                妊娠期糖尿病与胎儿畸形之间并无直接关联。但是，当孕妇血糖水平较高时，可能导致巨婴、新生儿黄疸、新生儿低血糖、呼吸困难、低钾血症、高胆红素血症及红细胞增多症等新生儿并发症发生率的增加。
            </p>
            <p class="bullet04 num2 depth">
                患有妊娠期糖尿病的孕妇产下体重超过4kg的巨婴概率较高，因此难产导致剖腹产的风险也相应增加。此外，由于羊水量增加，可能导致羊水过多，从而使子宫紧张，并引发早产。如果未能有效管理血糖，感染风险会显著上升，尤其是经常出现尿路感染。
            </p>
            <h4 class="bullet02 type2 num4 depth">产后护理</h4>
            <p class="depth">
                大多数患有妊娠期糖尿病的孕产妇在产后都能维持正常的血糖水平，而注射胰岛素的孕产妇也不再需要注射胰岛素。
                <br>
                但是，有研究表明，大约50%患有妊娠期糖尿病的产妇会在20年内发展为2型糖尿病。因此，产后应积极进行母乳喂养，持续控制体重和饮食，这样可以降低日后患糖尿病的风险。
            </p>
        </div>

        <div id="step5" class="step-item info">
            <h3 class="bullet01">前置胎盘</h3>
            <p class="depth">
                前置胎盘是指胎盘堵塞子宫全部或部分出口的状态，如果子宫颈打开，则存在血管破裂，导致大量出血的危险。
            </p>
            <h4 class="bullet02 type2 num1 depth">诊断</h4>
            <p class="depth">
                确定胎盘位置最简单、最准确、最安全的方法是使用超声波。
            </p>
            <h4 class="bullet02 type2 num2 depth">治疗</h4>
            <p class="bullet04 num1 depth">
                对于前置胎盘，最典型的症状是无痛性出血。但是，也可能发生伴随子宫收缩的早期阵痛。
            </p>
            <p class="bullet04 num2 depth">
                如果怀孕期间出现出血，应首先评估母体和胎儿状况，尽量采取保守治疗，并观察出血是否停止。但若出血量过大且胎儿情况不稳定，则需进行紧急剖腹产。
            </p>
            <p class="bullet04 num3 depth">
                前置胎盘不仅可导致产前出血，也是造成产后出血的重要原因。因此，选择在进行剖腹产手术后，能够对产后出血进行处置、紧急输血、进行子宫动脉栓塞术、子宫摘除术等的治疗机构进行手术更为安全。
            </p>

            <h4 class="bullet02 type2 num3 depth">产后护理</h4>
            <p class="depth">
                对于前置胎盘的产妇，通过手术完成分娩。在分娩后的24小时内，需密切观察以防止因子宫下部收缩不良而引起的大量出血情况的发生。
            </p>
        </div>

        <div id="step6" class="step-item info">
            <h3 class="bullet01">宫颈机能不全</h3>
            <p class="depth">孕中期或孕晚期的初期，发生无痛性宫颈扩张，胎膜膨出或破裂进入阴道，最终导致流产或早产。</p>
            <h4 class="bullet02 type2 num1 depth">原因</h4>
            <p class="depth">其原因尚不明确，但可能是子宫颈先天性异常所致，最常见的原因包括子宫颈外伤、频繁刮宫术、宫颈清扫、电疗或宫颈锥切术。</p>
            <h4 class="bullet02 type2 num2 depth">诊断</h4>
            <p class="bullet04 num1 depth">
                <span class="font-main">患者既往的产科史很重要。</span>
            </p>
            <p class="bullet04 num2 depth">
                “孕中期以后出现无痛性宫颈扩张，并伴有羊膜破裂早产的情况”有助于诊断。
            </p>
            <p class="bullet04 num3 depth">
                孕中期以后，无论是否伴随子宫收缩，即使没有早产或流产的经历，或以前没有这种经历，也可以通过超声波检查预测，如果子宫颈变短，则有可能患有宫颈机能不全。
            </p>
            <h4 class="bullet02 type2 num3 depth">治疗</h4>
            <p class="depth">
                宫颈机能不全的手术治疗方法是宫颈环形结扎术，根据手术方法的不同，有Mcdonald和Shirodkar两种方法。如果由于经阴道结扎术失败，或者子宫颈太短或受损严重而无法进行阴道结扎，则可以进行经腹环形宫颈结扎术。
            </p>
        </div>

        <div id="step7" class="step-item info">
            <h3 class="bullet01">多胎妊娠</h3>
            <p class="depth">
                多胎妊娠是指同时怀有两个或两个以上的胎儿，随着近年来辅助生殖技术的发展，多胎妊娠的发生率呈现出不断上升的趋势。
                <br>
                通过问诊确认是否存在家族史，检查后可能会发现孕妇腹部比普通孕妇更为隆起。最早可通过超声波进行诊断，并可在8-10周时观察到两个分离的孕囊和胎囊以确诊。通常，对于单胎妊娠而言，42周被视为延期妊娠，而对于双胎妊娠，40周被视为延期妊娠。
            </p>
            <h4 class="bullet02 type2 num1 depth">母亲对双胎妊娠的适应</h4>
            <p class="bullet04 num1 depth">怀孕初期，孕吐症状往往更加严重，同时在整个孕期内，对铁和叶酸的需求量也显著增加。</p>
            <p class="bullet04 num2 depth">流产风险增加，低出生体重、胎儿生长迟缓及畸形率可能上升；分娩时可能出现贫血、羊膜破裂引发早期阵痛、妊娠高血压、宫颈机能不全以及胎盘早剥等并发症。</p>
            <p class="bullet04 num3 depth">分娩过程中可能发生的并发症包括子宫功能障碍、胎盘粘连，产后并发症有产后出血。</p>

            <h4 class="bullet02 type2 num2 depth">多胎妊娠的并发症</h4>
            <p class="bullet04 num1 depth">自然流产与死胎</p>
            <p class="bullet05 depth">多胞胎妊娠早期流产的风险约为14%，是单胎妊娠流产风险的三倍，且胎儿数量越多，自然流产率越高。</p>
            <p class="bullet04 num2 depth">先兆子痫</p>
            <p class="bullet05 depth">与单胎妊娠相比，发生概率约高出2-3倍，而且发生时间较早。此外，妊娠期高血压导致的早产、胎儿发育延迟、胎盘早期剥离等并发症增加，新生儿并发症发生的风险也较高。</p>
            <p class="bullet04 num3 depth">早产</p>
            <p class="bullet05 depth">据韩国报道，双胎早产率为57%，妊娠平均周数为35周，三胎早产率为92%，妊娠平均周数32周。</p>
            <p class="bullet04 num4 depth">分娩并发症</p>
            <p class="bullet05 depth">
                多胎妊娠造成子宫肌肉极度拉伸，产后收缩力较弱，因此临产时阵痛不充分，产后出现失张力性子宫出血的可能性较大。因此，产前需做好紧急输血准备，以应对突发情况。
            </p>
            <p class="depth">
                此外，由于各种原因，母亲和胎儿发生紧急情况的概率较高。因此，必须做好应对紧急情况和手术的准备与医疗团队，同时在早产儿状况不佳时可以接受治疗的医疗环境中接受产前护理非常重要。
            </p>
        </div>

        <div id="step8" class="step-item info">
            <h3 class="bullet01">胎儿治疗</h3>
            <p class="depth">
                近年来，由于环境激素和空气污染的影响，胎儿畸形增多，在韩国，大约有3%至4%的新生儿出生时患有不同程度的先天性畸形。
                <br>
                梨花女子大学首尔医院胎儿治疗组利用高分辨率精密超声波对胎儿异常进行准确诊断，并开展一系列胎儿治疗，包括内科治疗、胸腔积液、腹水、膀胱穿刺术及胎儿分流术、针对胎儿贫血的胎儿输血、胎儿内窥镜检查下激光治疗、射频融合等手术治疗，以及分娩过程中的胎儿治疗等，提供韩国最高水平的胎儿治疗服务。
                <br>
                对存在某种缺陷的子宫内胎儿进行产前必要的手术，旨在阻止胎儿畸形或疾病的进一步发展，并追求最佳治疗结果，这是近年来针对几种先天性畸形正在尝试的一种治疗方法。胎儿疗法的适用性非常有限，必须满足以下几个条件：
            </p>
            <h4 class="bullet02 type2 num1 depth">胎儿治疗的条件</h4>
            <p class="bullet04 num1 depth">必须能够通过宫内治疗来纠正胎儿畸形的病因。</p>
            <p class="bullet04 num2 depth">应能准确诊断，评估畸形进展程度。</p>
            <p class="bullet04 num3 depth">必须对先天性畸形的自然病程和预后有深入的了解。</p>
            <p class="bullet04 num4 depth">必须是如果出生后尝试治疗，已造成不可逆转的损伤，因此必须进行产前治疗的情况。</p>
            <p class="bullet04 num5 depth">必须通过动物试验证明其有效性。</p>
            <p class="bullet04 num6 depth">必须在严格规划的胎儿治疗中心进行。</p>
            <p class="bullet04 num7 depth">必须向孕妇及其丈夫提供足够的信息，并获得知情同意书。</p>

            <h4 class="bullet02 type2 num2 depth">胎儿治疗的种类</h4>
            <p class="depth">胎儿治疗包括通过母体给药以治疗胎儿的内科治疗和直接对胎儿进行侵入性手术的手术治疗。</p>
            <p class="bullet04 num1 depth">内科治疗对象包括胎儿甲状腺异常、肾上腺肥大和心律失常。</p>
            <p class="bullet04 num2 depth">侵入性手术包括胎儿输血、胎儿分流手术和宫内胎儿手术，适应症包括双胎输血综合征、先天性膈疝、骶尾部畸胎瘤、先天性肺囊性乳腺瘤、肺隔离症以及脑膜脊髓膨出等。</p>
        </div>

        <div id="step9" class="step-item info">
            <h3 class="bullet01">产后出血</h3>
            <p class="depth">
                产后出血是指产妇在分娩后，出血量超过500毫升的情况，其主要直接原因是子宫收缩功能障碍所引发的失张力性子宫出血。此外，还有凝血障碍、胎盘滞留、胎盘粘连、子宫破裂、产道撕裂伤等。
            </p>
            <h4 class="bullet02 type2 num1 depth">子宫收缩乏力(uterine atony)</h4>
            <p class="bullet04 num1 depth">当发生子宫收缩乏力（uterine atony）时，最初可采取宫底按摩和药物治疗等内科治疗方法，常用的药物包括催产素、甲基麦角新碱等麦角衍生物、前列腺素以及卡贝缩宫素（carbetocin）等。</p>
            <p class="bullet04 num2 depth">
                但是，如果患者对子宫收缩剂无反应且持续出血，则应通过腹部及阴道双手压迫子宫（bimanual compression）的同时，进行输液及输血治疗，并考虑采取外科处理措施，如子宫动脉（uterine artery）结扎术、髂内动脉（hypogastric artery）结扎术、宫内球囊充盈、子宫加压缝合术、血管造影栓塞术以及子宫摘除术等。
            </p>

            <h4 class="bullet02 type2 num2 depth">动脉结扎术</h4>
            <p class="depth">
                动脉结扎术通常不会引发严重的并发症，且能够确保患者未来拥有正常的月经和生育能力。而子宫动脉结扎术因为阻断了怀孕期间负责90%子宫供血的血管，因此可以有效调节产后出血，由于子宫动脉升支沿着子宫侧壁与子宫肌层一同被结扎，因此相较于髂内动脉结扎术，该方法具有操作更简便、安全性更高的优点。
            </p>
            <h4 class="bullet02 type2 num3 depth">子宫摘除术 </h4>
            <p class="depth">
                子宫摘除术后，患者将丧失生育能力，且会进入永久性无月经状态，此外，还可能增加患者患产后抑郁症的风险，并有可能引发大出血及手后相关并发症。
            </p>
        </div>
    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>